import React, { FunctionComponent, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IFirmware } from 'interfaces';

interface IFirmwaresListItemProps {
    manufacturer: string;
    firmware: IFirmware;
}

export const FirmwaresListItem: FunctionComponent<IFirmwaresListItemProps> = ({ firmware, manufacturer }) => {
    const { t, i18n } = useTranslation();

    const editFirmwareURL = `/firmware-versions/${firmware.id}`;

    // Each string goes in a div as well as a title, so precompute translations to avoid doing them twice.
    const t_is_deleted = t('firmwaresList.item.isDeleted');
    const t_isDeletedTitle = t_is_deleted + ' ' + firmware.is_deleted;

    return (
        <li className="firmwaresItem" data-cy="deviceItem_device">
            
            <div className="firmwaresItem_iconCol firmwaresItem_col">
                <div className="firmwaresItem_iconCircle">
                    <FontAwesomeIcon icon="hdd" className="firmwaresItem_icon" />
                </div>
            </div>
            <div className="firmwaresItem_detailsCol firmwaresItem_col">
                <div className="firmwaresItem_name ellipsis" title={firmware.manufacturer_id + ''}>
                    {manufacturer}
                </div>
            </div>
            <div className="firmwaresItem_detailsCol firmwaresItem_col">
                <div className="firmwaresItem_name ellipsis" title={firmware.firmware_version}>
                    {firmware.firmware_version}
                </div>
            </div>
            {firmware.is_deleted ? (
                <div className="firmwaresItem_detailsCol firmwaresItem_col">
                    <div className="firmwaresItem_detailsLeft firmwaresItem_col">
                        <div className="ellipsis" title={t_isDeletedTitle}>
                            {t_is_deleted}
                        </div>
                    </div>
                    <div className="firmwaresItem_detailsRight firmwaresItem_col">
                        <div className="ellipsis" title={t_isDeletedTitle}>
                            True
                        </div>
                    </div>
                </div>
            ) : (<>
                <div className="firmwaresItem_detailsCol firmwaresItem_col">
                    <div className="firmwaresItem_detailsLeft">
                    </div>
                </div></>)}
            <Link
                to={editFirmwareURL}
                className="firmwaresItem_editCol"
                title={t('firmwaresList.item.editTooltip')}
                data-cy="deviceItem_editLink"
            >
                <FontAwesomeIcon icon={['far', 'edit']} className="firmwaresItem_editIcon" />
            </Link>
        </li>
    );
}